import Button from "element-ui/lib/button";
import Cascader from "element-ui/lib/cascader";
import Checkbox from "element-ui/lib/checkbox";
import CheckboxGroup from "element-ui/lib/checkbox-group";
import Collapse from "element-ui/lib/collapse";
import CollapseItem from "element-ui/lib/collapse-item";
import Container from "element-ui/lib/container";
import DatePicker from "element-ui/lib/date-picker";
import Dialog from "element-ui/lib/dialog";
import Drawer from "element-ui/lib/drawer";
import Dropdown from "element-ui/lib/dropdown";
import DropdownItem from "element-ui/lib/dropdown-item";
import DropdownMenu from "element-ui/lib/dropdown-menu";
import Form from "element-ui/lib/form";
import FormItem from "element-ui/lib/form-item";
import Input from "element-ui/lib/input";
import InputNumber from "element-ui/lib/input-number";
import Main from "element-ui/lib/main";
import Message from "element-ui/lib/message";
import Option from "element-ui/lib/option";
import Popover from "element-ui/lib/popover";
import Progress from "element-ui/lib/progress";
import Radio from "element-ui/lib/radio";
import RadioButton from "element-ui/lib/radio-button";
import RadioGroup from "element-ui/lib/radio-group";
import Select from "element-ui/lib/select";
import Skeleton from "element-ui/lib/skeleton";
import SkeletonItem from "element-ui/lib/skeleton-item";
import Slider from "element-ui/lib/slider";
import Switch from "element-ui/lib/switch";
import TabPane from "element-ui/lib/tab-pane";
import Table from "element-ui/lib/table";
import TableColumn from "element-ui/lib/table-column";
import Tabs from "element-ui/lib/tabs";
import Tag from "element-ui/lib/tag";
import Tooltip from "element-ui/lib/tooltip";
import Upload from "element-ui/lib/upload";
import Loading from "element-ui/lib/loading";
import locale from "element-ui/lib/locale";

const components = [
  Button,
  Cascader,
  Checkbox,
  CheckboxGroup,
  Collapse,
  CollapseItem,
  Container,
  DatePicker,
  Dialog,
  Drawer,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Form,
  FormItem,
  Input,
  InputNumber,
  Main,
  Option,
  Popover,
  Progress,
  Radio,
  RadioButton,
  RadioGroup,
  Select,
  Skeleton,
  SkeletonItem,
  Slider,
  Switch,
  TabPane,
  Table,
  TableColumn,
  Tabs,
  Tag,
  Tooltip,
  Upload,
];

export function installElementUI(Vue, i18n, options = {}) {
  locale.i18n((key, value) => i18n.t(key, value));
  components.forEach((component) => Vue.component(component.name, component));
  Vue.use(Loading.directive);

  Vue.prototype.$ELEMENT = {
    size: options.size || "",
    zIndex: options.zIndex || 2000,
  };
  Vue.prototype.$loading = Loading.service;
  Vue.prototype.$message = Message;
}
